/* global axios */
import ApiClient from '../ApiClient';

// Nested under an account (super_admin/accounts/:account_id/account_users) but the account in
// question isn't the current dashboard account — it's whichever one the SuperAdmin is looking
// at — so this can't reuse ApiClient's own accountScoped option (that always reads accountId
// from the current URL). Each method takes accountId explicitly instead.
class SuperAdminAccountUsersAPI extends ApiClient {
  constructor() {
    super('super_admin/accounts', { apiVersion: 'v1' });
  }

  get(accountId) {
    return axios.get(`${this.url}/${accountId}/account_users`);
  }

  create(accountId, data) {
    return axios.post(`${this.url}/${accountId}/account_users`, data);
  }

  update(accountId, id, data) {
    return axios.patch(`${this.url}/${accountId}/account_users/${id}`, data);
  }
}

export default new SuperAdminAccountUsersAPI();
